/* src/app/shared/components/ship-details-dialog/ship-details-dialog.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.ship-details-dialog {
  font-size: 1rem;
}
@media screen and (min-width: 48rem) {
  .ship-details-dialog .horizontal-medium {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: flex-start;
  }
}
.ship-details-dialog .dialog-header {
  margin-bottom: 0;
}
.ship-details-dialog .mat-mdc-dialog-content {
  padding: 0 8em 2em 2em;
}
.ship-details-dialog .mat-mdc-button.link {
  color: #009cbd;
  font-weight: 700;
}
.ship-details-dialog .mat-mdc-raised-button.send-email {
  background-color: #66c4d7;
}
.ship-details-dialog .mat-mdc-raised-button.print {
  background-color: #a2ca6d;
}
.ship-details-dialog .section {
  margin-bottom: 3em;
}
.ship-details-dialog .section.tracking-details .section-content .content-items {
  width: 100%;
}
@media screen and (min-width: 48rem) {
  .ship-details-dialog .section.tracking-details .section-content .content-items .content-item .value {
    flex-grow: 1;
  }
}
@media screen and (min-width: 48rem) {
  .ship-details-dialog .section.payment-information {
    margin-left: 5em;
  }
}
.ship-details-dialog .section-title {
  font-family: "Roboto Flex", sans-serif;
  color: #004791;
  margin-bottom: 1em;
}
.ship-details-dialog .section-content {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}
@media screen and (min-width: 48rem) {
  .ship-details-dialog .section-content {
    flex-direction: row;
  }
}
.ship-details-dialog .section-content .content-items {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  flex-wrap: wrap;
}
@media screen and (min-width: 48rem) {
  .ship-details-dialog .section-content .content-items {
    width: 25em;
  }
}
@media screen and (min-width: 48rem) {
  .ship-details-dialog .section-content .content-items.shipment-details {
    max-height: 12em;
    width: 50em;
  }
}
@media screen and (min-width: 48rem) {
  .ship-details-dialog .section-content .content-items.shipment-information {
    width: 20em;
  }
}
@media screen and (min-width: 48rem) {
  .ship-details-dialog .section-content .content-items.payment-information {
    width: 18em;
  }
}
.ship-details-dialog .section-content .content-items.payment-information .content-item .key {
  width: 13em;
}
.ship-details-dialog .section-content .content-items.payment-information .content-item .value {
  width: 5em;
}
.ship-details-dialog .section-content .content-items.payment-information .content-item.bill-to {
  margin: 10px 0 2.6em 0;
  padding-top: 0;
}
.ship-details-dialog .section-content .content-items.payment-information .content-item.bill-to .key {
  width: 5em;
  padding-right: 1em;
}
.ship-details-dialog .section-content .content-items.payment-information .content-item.total {
  border-top: 2px solid #d9d9d6;
  font-weight: 700;
  padding-top: 1em;
  margin-top: 1em;
}
.ship-details-dialog .section-content .content-items.payment-information .content-item.total .key {
  text-align: right;
  padding-right: 2em;
}
.ship-details-dialog .section-content .content-items .content-items-title {
  font-family: "Roboto Flex", sans-serif;
  font-weight: 700;
}
.ship-details-dialog .section-content .content-items .content-item {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-between;
  padding: 0.5em 0;
}
@media screen and (min-width: 48rem) {
  .ship-details-dialog .section-content .content-items .content-item {
    justify-content: flex-start;
  }
}
.ship-details-dialog .section-content .content-items .content-item .key,
.ship-details-dialog .section-content .content-items .content-item .value {
  width: 49%;
}
@media screen and (min-width: 48rem) {
  .ship-details-dialog .section-content .content-items .content-item .key,
  .ship-details-dialog .section-content .content-items .content-item .value {
    width: 12em;
  }
}
.ship-details-dialog .section-content .content-items .content-item .value {
  font-weight: 700;
}
/*# sourceMappingURL=ship-details-dialog.component.css.map */
